/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

function parseTNode(renderNode, renderParams, defaultNode) {
  var node = null;
  if (typeof renderNode === "function") {
    node = renderNode(renderParams);
  } else if (renderNode === true) {
    node = defaultNode;
  } else {
    node = renderNode !== null && renderNode !== void 0 ? renderNode : defaultNode;
  }
  return node;
}

export { parseTNode as default };
//# sourceMappingURL=parseTNode.js.map
